import { Injectable, Inject, AfterViewInit } from '@angular/core';


import { Observable, Subject } from 'rxjs';
import { PopupdisplayComponent } from '../popupdisplay/popupdisplay.component';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({

  providedIn: 'root'
})
@Injectable()
export class AlertmessageService {

  dialogRef: MatDialogRef<PopupdisplayComponent>
  private subject = new Subject<any>();
  // constructor(public dialog: MatDialog,public _router:Router){}
  constructor(public dialog: MatDialog,
    public _router: Router
  ) { }
  confirm(message: string, siFn: () => void, noFn: () => void) {
    console.log("on confirm");
    this.setConfirmation(message, siFn, noFn);
  }
  setConfirmation(message: string, siFn: () => void, noFn: () => void) {
    let that = this;
    console.log("set confirm");
    this.subject.next({
      type: "confirm",
      text: message,
      siFn:
        function () {
          that.subject.next(); //this will close the modal
          siFn();
        },
      noFn: function () {
        that.subject.next();
        noFn();
      }
    });

  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  openConfirmationDialo11(Msg, checking?: Boolean) {
    //this._bottomSheet.open(PopupdisplayComponent);
    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      // height: '75px',
      // width: '300px',
      //height: '140px',
      //width: '600px',

      data: {},
      disableClose: false
    });
    this.dialogRef.componentInstance.confirmMessage = Msg;

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        if (checking)
          console.log('test')
        this._router.navigate(['/enroll']).then(() => {
          window.location.reload();

        });
      }
      this.dialogRef = null;
    });

  }

  openConfirmationDialoDivisable(Msg, checking?: Boolean) {
    //this._bottomSheet.open(PopupdisplayComponent);
    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      height: '140px',
      width: '600px',


      data: {},
      disableClose: false
    });
    this.dialogRef.componentInstance.confirmMessage = Msg;

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (checking)
          console.log('test')
      }

      this.dialogRef = null;
    });
  }


  openConfirmationDialog(Msg, checking?: Boolean) {
    console.log(Msg);
    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      // height: '140px',
      //width: '500px',

      // height: '140px',
      // width: '400px',
      data: {},
      disableClose: false
    });
    this.dialogRef.componentInstance.confirmMessage = Msg;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
        if (checking)
          console.log('test')
        //this._router.navigate(['/dashboard'])

        // do confirmation actions
      }

      this.dialogRef = null;
    });
  }
  openConfirmationDialog1(Msg, checking?: Boolean) {
    console.log(Msg);
    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      height: '140px',
      width: '400px',
      data: {},
      disableClose: false
    });
    this.dialogRef.componentInstance.confirmMessage = Msg;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
        if (checking)
          console.log('test')
        this._router.navigate(['']);

        // do confirmation actions
      }

      this.dialogRef = null;
    });
  }

  openConfirmationDialogShot(Msg, checking?: Boolean) {

    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      height: '180px',
      width: '1000px',
      data: {},
      disableClose: false
    });
    this.dialogRef.componentInstance.confirmMessage = Msg;

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (checking)
          this._router.navigate(['/dashboard/enterexcesscurrency']);
        // do confirmation actions
      }

      this.dialogRef = null;
    });
  }


  openConfirmationDialogSave(Msg, checking?: boolean) {

    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      height: '400px',
      width: '400px',
      data: {},
      disableClose: false,


    });
    this.dialogRef.componentInstance.confirmMessage = Msg;
    //Msg.replace(".","<br>");
    //this.dialogRef.componentInstance.body = Msg;
    //   console.log(this.dialogRef.componentInstance.confirmMessage);
    //this.dialogRef.componentInstance.displaygrid=checking;

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        // do confirmation actions
      }

      this.dialogRef = null;
    });
  }
  openConfirmationDialogLong(Msg, checking?: Boolean) {

    this.dialogRef = this.dialog.open(PopupdisplayComponent, {
      height: '160px',
      width: '900px',
      data: {},
      disableClose: false
    });
    this.dialogRef.componentInstance.confirmMessage = Msg;

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        // do confirmation actions
      }

      this.dialogRef = null;
    });
  }
}
